import { AxiosResponse } from 'axios';

import {
  IDeleteAreasRequestFilters,
  IGetAreasRequestFilters,
  IGetAreasResponse,
  ICreateAreaRequestBody,
  ICreateAreaResponse,
  IUpdateAreaRequestBody,
  IUpdateAreaResponse,
  IGetSingleAreaResponse,
  IDeleteAreasResponse,
} from 'models/http/area';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { DataUploadModels, ModelsNames } from 'utils/enums/model-names';
import { prepareFiltersOfSelection, prepareQPFromFilters, serverAxios } from 'utils/http';
import { HTTP } from './core.http';
import DataUploadBaseHttp from './utils/data-upload.http';
import { IGetSimpleListFilters, IGetSimpleListResponse } from 'models/http/common';

class AreaHttp extends DataUploadBaseHttp implements HTTP<IDeleteAreasRequestFilters> {
  protected readonly route: DataUploadModels = ModelsNames.Areas;

  public async getSimple(filters?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    const queryParams = prepareQPFromFilters({ type: filters?.type});

    return serverAxios
      .get(`/${this.route}/simple?`, {
        params: queryParams,
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }

  public async get(filters?: IGetAreasRequestFilters, abortController?: AbortController): Promise<IGetAreasResponse['records']> {
    const queryParams = prepareQPFromFilters(filters || {});

    return serverAxios
      .get(this.route, {
        params: queryParams,
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetAreasResponse>) => {
        return response.data.records;
      });
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetSingleAreaResponse> {
    return serverAxios
      .get(`/${this.route}/single/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSingleAreaResponse>) => {
        return response.data;
      });
  }

  public async create(data: ICreateAreaRequestBody): Promise<ICreateAreaResponse> {
    return serverAxios
      .post(`/${this.route}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateAreaResponse>) => {
        return response.data;
      });
  }

  public async  update(id: number, data: IUpdateAreaRequestBody): Promise<IUpdateAreaResponse> {
    return serverAxios
      .put(`/${this.route}/${id}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IUpdateAreaResponse>) => {
        return response.data;
      });
  }

  public async delete(ids: number[]): Promise<IDeleteAreasResponse>;
  public async delete(filters: IDeleteAreasRequestFilters): Promise<IDeleteAreasResponse>;
  public async delete(filters: number[] | IDeleteAreasRequestFilters): Promise<IDeleteAreasResponse> {
    return serverAxios
      .delete(`/${this.route}`, {
        data: prepareFiltersOfSelection(filters),
      })
      .then((response: AxiosResponse<IDeleteAreasResponse>) => {
        return response.data;
      });
  }
}

export default AreaHttp;
